import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { categories, videos } from "@/mocks/videos";
import { usePageMeta } from "@/hooks/usePageMeta";

const scopeItems = [
  {
    icon: "ri-film-line",
    title: "影视片段精选",
    desc: "整理经典影视作品中的亲吻片段，标注出处与背景，方便按场景查找。",
  },
  {
    icon: "ri-video-line",
    title: "短视频合集",
    desc: "收录时长精简、节奏轻快的亲吻短视频，适合碎片时间浏览。",
  },
  {
    icon: "ri-heart-3-line",
    title: "情感专题",
    desc: "围绕告白、重逢、陪伴等主题策划合集，用故事串联同类内容。",
  },
];

export default function AboutPage() {
  const total = videos.length;

  usePageMeta(
    "关于我们 - 亲嘴视频",
    "了解亲嘴视频的平台定位、品牌故事与内容范围，聚焦影视片段、短视频与情感专辑等亲吻主题视频资源。"
  );

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 pt-10 md:pt-16 pb-12 md:pb-16 bg-background-100">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label mb-5">
            <i className="ri-heart-3-fill" />
            关于亲嘴视频
          </div>
          <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-5">
            让每一个动人的亲吻瞬间
            <br className="hidden md:block" />
            都能被轻松找到
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            亲嘴视频是一个专注亲吻主题的视频内容平台，收录影视片段精选、短视频合集与情感专题三类资源。我们相信，银幕与生活里那些温柔的一刻值得被好好整理，也值得被更多人看到。
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              回到首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-secondary-100 text-secondary-900 text-sm font-medium hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line" />
              搜索视频
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-14">
          {[
            { label: "收录作品", value: `${total}+` },
            { label: "内容分类", value: `${categories.length}` },
            { label: "专题合集", value: "3" },
            { label: "持续更新", value: "每日" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 text-center"
            >
              <p className="font-heading text-2xl md:text-4xl text-primary-600 mb-1">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-500 font-label">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        <div className="mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            品牌故事
          </h2>
          <div className="max-w-3xl space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              一切始于一个很简单的想法：当你想找一段印象深刻的亲吻片段时，往往要在各种平台之间反复搜索，结果却未必满意。于是我们决定做一个专门聚焦这一主题站点，把散落各处的优质内容重新归拢、分类与整理。
            </p>
            <p>
              我们不满足于做一个简单的视频列表。围绕「场景」「情绪」与「出处」三个维度，我们对每一部作品都做了标签化整理，让你既可以从分类进入，也可以顺着专题一路看下去，找到更多风格接近的推荐。
            </p>
            <p>
              目前站点为演示阶段，所有视频与播放均为前端演示，旨在呈现完整的浏览、筛选与观看体验。后续我们会持续扩充内容丰富度与播放能力。
            </p>
          </div>
        </div>

        <div className="mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
            内容范围
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {scopeItems.map((item) => (
              <div
                key={item.title}
                className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <h3 className="font-medium text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-primary-950 p-6 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-2">
              联系我们
            </h2>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-xl">
              如果你有内容建议、合作意向或任何反馈，欢迎通过邮箱与我们联系，我们会尽快回复。
            </p>
          </div>
          <div className="shrink-0">
            <p className="text-xs text-background-200/60 font-label mb-2">
              反馈邮箱
            </p>
            <a
              href="mailto:contact@qinzui-video.example"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line" />
              contact@qinzui-video.example
            </a>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}